import { useTranslation } from "react-i18next";

import { IntegrationsRow } from "@/Pages/Integrations/types";
import Dialog from "@/components/Dialog/Dialog";
import { DialogWidth } from "@/components/Dialog/types/enums";
import { useMediaQueries } from "@/shared";
import DialogActions from "@/shared/components/buttons/DialogActions";

interface DisableIntegrationDialogProps {
  rowData: IntegrationsRow;
  isOpen: boolean;
  isLoading: boolean;
  handleDisableSubmit: (rowData: IntegrationsRow) => Promise<void>;
  handleClose: () => void;
}

const DisableIntegrationDialog = ({
  rowData,
  isOpen,
  isLoading,
  handleDisableSubmit,
  handleClose
}: DisableIntegrationDialogProps) => {
  const { toMd } = useMediaQueries();
  const { t } = useTranslation();

  return (
    <Dialog
      data-testid="disable-integration-dialog"
      title={t(`Dialog##integrations##disable integration##title`)}
      description={t(`Dialog##integrations##disable integration##description`, {
        integrationName: rowData.name
      })}
      open={isOpen}
      isTitleSeparator
      width={toMd ? undefined : DialogWidth.MinWidth}
      extendToMaxWidth={toMd}
      close={handleClose}
      submit={() => handleDisableSubmit(rowData)}
      actions={
        <DialogActions
          onClose={handleClose}
          isLoading={isLoading}
          isreadyToConfirm
          confirmationButtonText={t("Button##disable")}
          confirmationButtonTestId="disable-integration-confirmation-button"
          cancelButtonText={t("Button##close")}
          cancelButtonTestId="disable-integration-cancel-button"
        />
      }
    />
  );
};

export default DisableIntegrationDialog;
